(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    class HoverMedia extends HTMLElement {
    #abortController = new AbortController();

    connectedCallback() {
      this.video = this.querySelector('video');

      if (!(this.video instanceof HTMLVideoElement)) {
        return;
      }

      this.video.muted = true;
      this.video.playsInline = true;

      this.interactiveRoot = this.closest('.image-block') ?? this;

      const signal = this.#abortController.signal;

      this.interactiveRoot.addEventListener('pointerenter', this.activate, { signal });
      this.interactiveRoot.addEventListener('pointerleave', this.deactivate, { signal });
      this.interactiveRoot.addEventListener('focusin', this.activate, { signal });
      this.interactiveRoot.addEventListener('focusout', this.handleFocusOut, { signal });
    }

    disconnectedCallback() {
      this.#abortController.abort();
    }

    activate = () => {
      this.classList.add('image-block__media--is-active');
      this.video.play()?.catch(() => {});
    };

    deactivate = () => {
      this.classList.remove('image-block__media--is-active');
      this.video.pause();
      this.video.currentTime = 0;
    };

    handleFocusOut = (event) => {
      if (event.relatedTarget instanceof Node && this.interactiveRoot.contains(event.relatedTarget)) {
        return;
      }

      this.deactivate();
    };
  }

  if (!customElements.get('hover-media')) {
    customElements.define('hover-media', HoverMedia);
  }
  } catch(e) { console.error(e); }
})();

})();
